export const onPremises = (): boolean =>
  import.meta.env.VITE_VERSION === 'onpremises';
